import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import micromodal from 'micromodal';
import { Observable, of, Subject } from 'rxjs';
import { filter, take, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'bom-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit, OnDestroy {
  @Input()
  title: string;

  @Input()
  isOpen$: Subject<boolean>;

  @Input()
  minWidthPx = 0;

  @Input()
  minHeightPercent: number;

  @Input()
  maxWidthPx = 1200;

  @Input()
  canClose$: Observable<boolean> = of(true);

  @ViewChild('closeButton', { static: true }) closeButton: ElementRef;

  id: string;

  private isOpen = false;
  private componentDestroyed$ = new Subject();

  constructor() {}

  ngOnInit() {
    // generate random id for this modal
    this.id = `bom-modal-${Math.random() * 1000000}`;
    const configuration = {
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close',
      disableScroll: true,
      disableFocus: true,
      awaitCloseAnimation: false,
      debugMode: false,
    };
    micromodal.init(configuration);

    this.isOpen$
      .pipe(
        takeUntil(this.componentDestroyed$),
        tap(isOpen => {
          try {
            if (isOpen) {
              micromodal.show(this.id);
              this.closeButton.nativeElement.focus();
            } else if (!isOpen && this.isOpen) {
              micromodal.close(this.id);
            }

            this.isOpen = isOpen;
          } catch (error) {
            // Ignore micromodal errors.
            // This may happen when switching from one
            // component with a modal to another component that has a modal
          }
        })
      )
      .subscribe();
  }

  close() {
    this.canClose$
      .pipe(
        take(1),
        filter(canClose => canClose),
        tap(() => this.isOpen$.next(false))
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
